(() => {
//var Math = require('mathjs')
/**
* Mathオブジェクトを拡張 
*/ var $6aa1fa05a881063f$var$Math = window.Math || {};
/**
* 与えられた値の小数点以下の桁数を返す 
* multiply, subtractで使用
* 
* 例)
*   10.12  => 2  
*   99.999 => 3
*   33.100 => 1
*/ $6aa1fa05a881063f$var$Math._getDecimalLength = function(value) {
    var list = (value + '').split('.'), result1 = 0;
    if (list[1] !== undefined && list[1].length > 0) result1 = list[1].length;
    return result1;
};
/**
* 乗算処理
*
* value1, value2から小数点を取り除き、整数値のみで乗算を行う。 
* その後、小数点の桁数Nの数だけ10^Nで除算する
*/ $6aa1fa05a881063f$var$Math.multiply = function(value1, value2) {
    var intValue1 = +(value1 + '').replace('.', ''), intValue2 = +(value2 + '').replace('.', ''), decimalLength = $6aa1fa05a881063f$var$Math._getDecimalLength(value1) + $6aa1fa05a881063f$var$Math._getDecimalLength(value2), result1;
    result1 = intValue1 * intValue2 / $6aa1fa05a881063f$var$Math.pow(10, decimalLength);
    return result1;
};
/**
* 減算処理
*
* value1,value2を整数値に変換して減算
* その後、小数点の桁数分だけ小数点位置を戻す
*/ $6aa1fa05a881063f$var$Math.subtract = function(value1, value2) {
    var max = $6aa1fa05a881063f$var$Math.max($6aa1fa05a881063f$var$Math._getDecimalLength(value1), $6aa1fa05a881063f$var$Math._getDecimalLength(value2)), k = $6aa1fa05a881063f$var$Math.pow(10, max);
    return ($6aa1fa05a881063f$var$Math.multiply(value1, k) - $6aa1fa05a881063f$var$Math.multiply(value2, k)) / k;
};
/**
* 加算処理
*
* value1,value2を整数値に変換して加算
* その後、小数点の桁数分だけ小数点位置を戻す
*/ $6aa1fa05a881063f$var$Math.addition = function(value1, value2) {
    var max = $6aa1fa05a881063f$var$Math.max($6aa1fa05a881063f$var$Math._getDecimalLength(value1), $6aa1fa05a881063f$var$Math._getDecimalLength(value2)), k = $6aa1fa05a881063f$var$Math.pow(10, max);
    return ($6aa1fa05a881063f$var$Math.multiply(value1, k) + $6aa1fa05a881063f$var$Math.multiply(value2, k)) / k;
};
var $6aa1fa05a881063f$var$_reqkinn = '';
var $6aa1fa05a881063f$var$_reqrate = '';
var $6aa1fa05a881063f$var$_reqstep = '';
var $6aa1fa05a881063f$var$_reqnenn = '';
window.calc_x = $6aa1fa05a881063f$var$calc_x;
function $6aa1fa05a881063f$var$calc_x(ks) {
    var op = {};
    op.ks = ks; //1:終価係数 2:現価係数 3:年金終価係数 4:年金現価係数 5:減債基金係数 6:資本回収係数
    op.rk = 2; //係数小数点以下 0:3桁 1:5桁 2:7桁 3:9桁
    op.rf = 0; //係数まるめ処理 0:Round 1:Ceil 2:Floor
    op.kk = 0; //金額小数点以下 0:0桁 1:2桁 2:4桁
    op.kf = 0; //金額まるめ処理 0:Round 1:Ceil 2:Floor
    op.ri = 4; // 年利率％小数点以下桁数
    op.rm = 20; // 最大年利率
    op.sp = 1; // 最大年利率幅
    op.nw = 11; // 表示行数
    op.nm = 50; // 最大年数
    var reqkinn = document.getElementById('reqkinn-x');
    var reqrate = document.getElementById('reqrate-x');
    var reqstep = document.getElementById('reqstep-x');
    var reqnenn = document.getElementById('reqnenn-x');
    var msgarea = document.getElementById('msgarea-x');
    // ^ 入力の先頭にマッチします。
    // $ 入力の末尾にマッチします。
    // * 直前の文字の 0 回以上の繰り返しにマッチします。{0,}に相当します。
    // + 直前の文字の 1 回以上の繰り返しにマッチします。{1,}に相当します。
    // ? 直前の文字の 0 回か 1 回の出現にマッチします。{0,1}に相当します。
    //
    var ma = false;
    switch(ks){
        case 1:
            ma = reqkinn.value.match(/^([0-9]{1,5})$/);
            break;
        case 3:
        case 4:
            ma = reqkinn.value.match(/^([0-9]{1,4})$/);
            break;
        case 2:
        case 5:
        case 6:
            ma = reqkinn.value.match(/^([0-9]{1,8})$/);
            break;
    }
    if (ma) $6aa1fa05a881063f$var$_reqkinn = reqkinn.value;
    else if (reqkinn.value.length == 0) {
        reqkinn.value = '';
        $6aa1fa05a881063f$var$_reqkinn = reqkinn.value;
    } else reqkinn.value = $6aa1fa05a881063f$var$_reqkinn;
    op.ikin = $6aa1fa05a881063f$var$_reqkinn;
    if (reqrate.value.match(/^([0-9]{0,2})(\.[0-9]{0,4})?$/)) {
        if ($6aa1fa05a881063f$var$stoRate(reqrate.value) > op.rm) reqrate.value = $6aa1fa05a881063f$var$_reqrate;
        else $6aa1fa05a881063f$var$_reqrate = reqrate.value;
    } else if (reqrate.value.length == 0) {
        reqrate.value = '';
        $6aa1fa05a881063f$var$_reqrate = reqrate.value;
    } else reqrate.value = $6aa1fa05a881063f$var$_reqrate;
    op.rate = $6aa1fa05a881063f$var$_reqrate;
    if (reqstep.value.match(/^([0-9]{0,1})(\.[0-9]{0,4})?$/)) {
        if ($6aa1fa05a881063f$var$stoRate(reqstep.value) > op.sp) reqstep.value = $6aa1fa05a881063f$var$_reqstep;
        else $6aa1fa05a881063f$var$_reqstep = reqstep.value;
    } else if (reqstep.value.length == 0) {
        reqstep.value = '';
        $6aa1fa05a881063f$var$_reqstep = reqstep.value;
    } else reqstep.value = $6aa1fa05a881063f$var$_reqstep;
    op.step = $6aa1fa05a881063f$var$_reqstep;
    if (reqnenn.value.match(/^([0-9]{1,2})$/)) {
        if ($6aa1fa05a881063f$var$stoNumber(reqnenn.value) > op.nm) reqnenn.value = $6aa1fa05a881063f$var$_reqnenn;
        else $6aa1fa05a881063f$var$_reqnenn = reqnenn.value;
    } else if (reqnenn.value.length == 0) {
        reqnenn.value = '';
        $6aa1fa05a881063f$var$_reqnenn = reqnenn.value;
    } else reqnenn.value = $6aa1fa05a881063f$var$_reqnenn;
    op.nenn = $6aa1fa05a881063f$var$_reqnenn;
    var rk0 = document.getElementById('rk0-x');
    var rk1 = document.getElementById('rk1-x');
    var rk2 = document.getElementById('rk2-x');
    var rk3 = document.getElementById('rk3-x');
    if (rk0.checked) op.rk = 0;
    else if (rk1.checked) op.rk = 1;
    else if (rk2.checked) op.rk = 2;
    else if (rk3.checked) op.rk = 3;
    var rf0 = document.getElementById('rf0-x');
    var rf1 = document.getElementById('rf1-x');
    var rf2 = document.getElementById('rf2-x');
    if (rf0.checked) op.rf = 0;
    else if (rf1.checked) op.rf = 1;
    else if (rf2.checked) op.rf = 2;
    var kk0 = document.getElementById('kk0-x');
    var kk1 = document.getElementById('kk1-x');
    var kk2 = document.getElementById('kk2-x');
    if (kk0.checked) op.kk = 0;
    else if (kk1.checked) op.kk = 1;
    else if (kk2.checked) op.kk = 2;
    var kf0 = document.getElementById('kf0-x');
    var kf1 = document.getElementById('kf1-x');
    var kf2 = document.getElementById('kf2-x');
    if (kf0.checked) op.kf = 0;
    else if (kf1.checked) op.kf = 1;
    else if (kf2.checked) op.kf = 2;
    let values = $6aa1fa05a881063f$var$mainCalc(op);
    for(var ix = 0; ix < 11; ix++)for(var jx = 0; jx < 4; jx++){
        var roco = 'ro' + ix + 'co' + jx + '-x';
        document.getElementById(roco).innerHTML = values[ix][jx];
        if (values[ix][0] == $6aa1fa05a881063f$var$fixedRate(op.rate, op.ri)) {
            document.getElementById(roco).style.backgroundColor = '#ffe8d1';
            document.getElementById(roco).style.fontWeight = 'bold';
        } else {
            document.getElementById(roco).style.backgroundColor = '#d1ffd1';
            document.getElementById(roco).style.fontWeight = 'normal';
        }
        document.getElementById(roco).style.color = '#000000';
    }
    let valuesx = $6aa1fa05a881063f$var$mainCalcx(op);
    for(var ix = 0; ix < 11; ix++)for(var jx = 0; jx < 3; jx++){
        var roco = 'xro' + ix + 'co' + jx + '-x';
        document.getElementById(roco).innerHTML = valuesx[ix][jx];
        if (valuesx[ix][0] == op.nenn) {
            document.getElementById(roco).style.backgroundColor = '#ffe8d1';
            document.getElementById(roco).style.fontWeight = 'bold';
        } else {
            document.getElementById(roco).style.backgroundColor = '#d1ffd1';
            document.getElementById(roco).style.fontWeight = 'normal';
        }
        document.getElementById(roco).style.color = '#000000';
    }
}
function $6aa1fa05a881063f$var$mainCalc(op) {
    var _ikin = $6aa1fa05a881063f$var$stoNumber(op.ikin);
    var _rate = $6aa1fa05a881063f$var$stoFixedRateInt(op.rate, op.ri);
    var _step = $6aa1fa05a881063f$var$stoFixedRateInt(op.step, op.ri);
    var _nenn = $6aa1fa05a881063f$var$stoNumber(op.nenn);
    var cikin = false;
    if (_ikin > 0) cikin = true;
    var crate = false;
    if (_rate > 0) crate = true;
    var cstep = false;
    if (_step > 0) cstep = true;
    var cnenn = false;
    if (_nenn > 0) cnenn = true;
    switch(op.rk){
        case 0:
            _rn = 3;
            break;
        case 1:
            _rn = 5;
            break;
        case 2:
            _rn = 7;
            break;
        case 3:
            _rn = 9;
            break;
        default:
            _rn = 9;
            break;
    }
    switch(op.kk){
        case 0:
            _kn = 0;
            break;
        case 1:
            _kn = 2;
            break;
        case 2:
            _kn = 4;
            break;
        default:
            _kn = 0;
            break;
    }
    var orit = 0;
    var kesu = 0;
    var okin = 0;
    var mkesu = 0;
    var mokin = 0;
    var sgaku = 0;
    let values = [];
    var _p0 = $6aa1fa05a881063f$var$Math.pow(10, op.ri);
    var _p2 = $6aa1fa05a881063f$var$Math.pow(10, op.ri + 2);
    var _bd = BigNumber(_p2).plus(_rate);
    var _ba = BigNumber(_bd).div(_p2);
    _sn = (op.nw - 1) / -2;
    _en = (op.nw - 1) / 2;
    if (crate) {
        if (cnenn) {
            mkesu = $6aa1fa05a881063f$var$calculateFactor(op, _rn, _ba, _rate, _nenn);
            if (cikin) mokin = $6aa1fa05a881063f$var$r($6aa1fa05a881063f$var$Math.multiply(_ikin * _p0, $6aa1fa05a881063f$var$stoRate(mkesu)), _kn, op.kf);
            else mokin = 0;
        } else {
            mkesu = 0;
            mokin = 0;
        }
    } else {
        mkesu = 0;
        mokin = 0;
    }
    for(var ix = _sn; ix < _en + 1; ix++)if (cstep) {
        if (crate) {
            orit = $6aa1fa05a881063f$var$Math.multiply(ix, _step) + _rate;
            if (orit <= 0) {
                _en += 1;
                continue;
            }
            if (cnenn) {
                _ba = (_p2 + orit) / _p2;
                kesu = $6aa1fa05a881063f$var$calculateFactor(op, _rn, _ba, orit, _nenn);
                if (cikin) {
                    okin = $6aa1fa05a881063f$var$r($6aa1fa05a881063f$var$Math.multiply(_ikin * _p0, $6aa1fa05a881063f$var$stoRate(kesu)), _kn, op.kf);
                    sgaku = $6aa1fa05a881063f$var$r($6aa1fa05a881063f$var$Math.subtract($6aa1fa05a881063f$var$stoRate(okin), $6aa1fa05a881063f$var$stoRate(mokin)), _kn, op.kf);
                    values.push([
                        $6aa1fa05a881063f$var$fixedRate(orit / $6aa1fa05a881063f$var$Math.pow(10, op.ri), op.ri),
                        kesu,
                        $6aa1fa05a881063f$var$sepCurr(okin),
                        $6aa1fa05a881063f$var$sepCurr(sgaku)
                    ]);
                } else values.push([
                    $6aa1fa05a881063f$var$fixedRate(orit / $6aa1fa05a881063f$var$Math.pow(10, op.ri), op.ri),
                    kesu,
                    "\u2500\u2500\u2500\u2500\u2500\u2500",
                    "\u2500\u2500\u2500\u2500\u2500\u2500"
                ]);
            } else values.push([
                $6aa1fa05a881063f$var$fixedRate(orit / $6aa1fa05a881063f$var$Math.pow(10, op.ri), op.ri),
                "\u2500\u2500\u2500\u2500\u2500\u2500",
                "\u2500\u2500\u2500\u2500\u2500\u2500",
                "\u2500\u2500\u2500\u2500\u2500\u2500"
            ]);
        } else values.push([
            "\u2500\u2500\u2500\u2500\u2500\u2500",
            "\u2500\u2500\u2500\u2500\u2500\u2500",
            "\u2500\u2500\u2500\u2500\u2500\u2500",
            "\u2500\u2500\u2500\u2500\u2500\u2500"
        ]);
    } else values.push([
        "\u2500\u2500\u2500\u2500\u2500\u2500",
        "\u2500\u2500\u2500\u2500\u2500\u2500",
        "\u2500\u2500\u2500\u2500\u2500\u2500",
        "\u2500\u2500\u2500\u2500\u2500\u2500"
    ]);
    return values;
}
function $6aa1fa05a881063f$var$mainCalcx(op) {
    var _ikin = $6aa1fa05a881063f$var$stoNumber(op.ikin);
    var _rate = $6aa1fa05a881063f$var$stoFixedRateInt(op.rate, op.ri);
    var _nenn = $6aa1fa05a881063f$var$stoNumber(op.nenn);
    var _p0 = $6aa1fa05a881063f$var$Math.pow(10, op.ri);
    var _p2 = $6aa1fa05a881063f$var$Math.pow(10, op.ri + 2);
    var _ba = $6aa1fa05a881063f$var$Math.addition(_p2, _rate) / _p2;
    var cikin = false;
    if (_ikin > 0) cikin = true;
    var crate = false;
    if (_rate > 0) crate = true;
    var cnenn = false;
    if (_nenn > 0) cnenn = true;
    else _nenn = 1;
    switch(op.rk){
        case 0:
            _rn = 3;
            break;
        case 1:
            _rn = 5;
            break;
        case 2:
            _rn = 7;
            break;
        case 3:
            _rn = 9;
            break;
        default:
            _rn = 7;
            break;
    }
    switch(op.kk){
        case 0:
            _kn = 0;
            break;
        case 1:
            _kn = 2;
            break;
        case 2:
            _kn = 4;
            break;
        default:
            _kn = 0;
            break;
    }
    var kesu = 0;
    var okin = 0;
    let values = [];
    if (_nenn < $6aa1fa05a881063f$var$Math.floor(op.nw / 2) + 1) {
        _sn = 1;
        _en = op.nw;
    } else if (_nenn + $6aa1fa05a881063f$var$Math.floor(op.nw / 2) > op.nm) {
        _sn = op.nm - op.nw + 1;
        _en = op.nm;
    } else {
        _sn = _nenn - $6aa1fa05a881063f$var$Math.floor(op.nw / 2);
        _en = _sn + op.nw - 1;
    }
    for(var ix = _sn; ix < _en + 1; ix++)if (crate) {
        kesu = $6aa1fa05a881063f$var$calculateFactor(op, _rn, _ba, _rate, ix);
        if (cikin) {
            okin = $6aa1fa05a881063f$var$r($6aa1fa05a881063f$var$Math.multiply(_ikin * _p0, $6aa1fa05a881063f$var$stoRate(kesu)), _kn, op.kf);
            values.push([
                ix,
                kesu,
                okin,
                1
            ]);
        } else values.push([
            ix,
            kesu,
            "\u2500\u2500\u2500\u2500\u2500\u2500",
            1
        ]);
    } else values.push([
        ix,
        "\u2500\u2500\u2500\u2500\u2500\u2500",
        "\u2500\u2500\u2500\u2500\u2500\u2500",
        0
    ]);
    return values;
}
function $6aa1fa05a881063f$var$calculateFactor(op, rn, ba, rate, nenn) {
    let kesu = 0;
    switch(op.ks){
        //1:終価係数
        case 1:
            //  kesu = r(Math.pow(ba, nenn), rn, op.rf);
            var _c = BigNumber(ba).pow(nenn);
            kesu = $6aa1fa05a881063f$var$r(BigNumber(_c).toNumber(), rn, op.rf);
            break;
        //  2:現価係数
        case 2:
            //  var _t = Math.pow(ba, nenn);
            //  var _c = 1 / _t;
            //  var _cd = Math.floor(Math.multiply(_c, Math.pow(10, 16)));
            //  kesu = r(_cd / Math.pow(10, 16), rn, op.rf);
            //  kesu = r(Math.pow(ba, -1*nenn), rn, op.rf);
            var _t = BigNumber(ba).pow(nenn);
            var _c = BigNumber(1).div(_t);
            kesu = $6aa1fa05a881063f$var$r(BigNumber(_c).toNumber(), rn, op.rf);
            break;
        //3:年金終価係数
        case 3:
            //  var rate0 = rate/Math.pow(10, op.ri + 2);
            //  var _c = Math.pow(ba, nenn);
            //  kesu = r((_c - 1)/rate0, rn, op.rf);
            var rate0 = BigNumber(rate).div($6aa1fa05a881063f$var$Math.pow(10, op.ri + 2));
            var _c = BigNumber(ba).pow(nenn);
            var _s = BigNumber(_c).minus(1);
            var _k = BigNumber(_s).div(rate0);
            kesu = $6aa1fa05a881063f$var$r(BigNumber(_k).toNumber(), rn, op.rf);
            break;
        //4:年金現価係数
        case 4:
            //  var rate0 = rate/Math.pow(10, op.ri + 2);
            //  var _c = Math.pow(ba, -1*nenn);
            //  var _t = Math.pow(ba, nenn);
            //  var _c = 1 / _t;
            //  var _cd = Math.floor(Math.multiply(_c, Math.pow(10, 16)));
            //  _c = _cd / Math.pow(10, 16);
            //  kesu = r((1 - _c)/rate0, rn, op.rf);
            var rate0 = BigNumber(rate).div($6aa1fa05a881063f$var$Math.pow(10, op.ri + 2));
            var _t = BigNumber(ba).pow(nenn);
            var _c = BigNumber(1).div(_t);
            var _s = BigNumber(1).minus(_c);
            var _k = BigNumber(_s).div(rate0);
            kesu = $6aa1fa05a881063f$var$r(BigNumber(_k).toNumber(), rn, op.rf);
            break;
        //5:減債基金係数
        case 5:
            //  var rate0 = rate/Math.pow(10, op.ri + 2);
            //  var _c = Math.pow(ba, nenn);
            //  kesu = r(rate0/(_c - 1), rn, op.rf);
            var rate0 = BigNumber(rate).div($6aa1fa05a881063f$var$Math.pow(10, op.ri + 2));
            var _c = BigNumber(ba).pow(nenn);
            var _s = BigNumber(_c).minus(1);
            var _k = BigNumber(rate0).div(_s);
            kesu = $6aa1fa05a881063f$var$r(BigNumber(_k).toNumber(), rn, op.rf);
            break;
        //6:資本回収係数
        case 6:
            //  var rate0 = rate/Math.pow(10, op.ri + 2);
            //  var _c = Math.pow(ba, -1*nenn);
            //  var _t = Math.pow(ba, nenn);
            //  var _c = 1 / _t;
            //  var _cd = Math.floor(Math.multiply(_c, Math.pow(10, 16)));
            //  op.rf == 2 ? _cd += 10 : _cd -= 5;
            //  _c = _cd / Math.pow(10, 16);
            //  kesu = r(rate0/(1 - _c), rn, op.rf);
            var rate0 = BigNumber(rate).div($6aa1fa05a881063f$var$Math.pow(10, op.ri + 2));
            var _t = BigNumber(ba).pow(nenn);
            var _c = BigNumber(1).div(_t);
            var _s = BigNumber(1).minus(_c);
            var _k = BigNumber(rate0).div(_s);
            kesu = $6aa1fa05a881063f$var$r(BigNumber(_k).toNumber(), rn, op.rf);
            break;
    }
    return kesu;
}
// (){} まるめ処理
function $6aa1fa05a881063f$var$r(number, n, f) {
    switch(f){
        case 0:
            result = $6aa1fa05a881063f$var$roundFormat(number, n);
            break;
        case 1:
            result = $6aa1fa05a881063f$var$ceilFormat(number, n);
            break;
        case 2:
            result = $6aa1fa05a881063f$var$floorFormat(number, n);
            break;
        default:
            result = number;
            break;
    }
    return $6aa1fa05a881063f$var$sepCurr(result);
}
// (){} シフト
function $6aa1fa05a881063f$var$shift(number, precision, reverseShift) {
    if (reverseShift) precision = -precision;
    var numArray = ("" + number).split("e");
    return +(numArray[0] + "e" + (numArray[1] ? +numArray[1] + precision : precision));
}
// (){} 切り上げ
function $6aa1fa05a881063f$var$ceilFormat(number, n) {
    return $6aa1fa05a881063f$var$fixedRate($6aa1fa05a881063f$var$shift($6aa1fa05a881063f$var$Math.ceil($6aa1fa05a881063f$var$shift(number, n, false)), n, true), n);
}
// (){} 四捨五入
function $6aa1fa05a881063f$var$roundFormat(number, n) {
    return $6aa1fa05a881063f$var$fixedRate($6aa1fa05a881063f$var$shift($6aa1fa05a881063f$var$Math.round($6aa1fa05a881063f$var$shift(number, n, false)), n, true), n);
}
// {}{} 切り捨て
function $6aa1fa05a881063f$var$floorFormat(number, n) {
    return $6aa1fa05a881063f$var$fixedRate($6aa1fa05a881063f$var$shift($6aa1fa05a881063f$var$Math.floor($6aa1fa05a881063f$var$shift(number, n, false) + 0.1), n, true), n);
}
// (){} 数値表現（整数）
function $6aa1fa05a881063f$var$stoNumber(numvalue) {
    if (numvalue.length == 0) return 0;
    else return parseInt(numvalue.replace(/,/g, ''));
}
// (){} 数値表現（浮動小数）
function $6aa1fa05a881063f$var$stoRate(numvalue) {
    if (numvalue.length == 0) return 0;
    else return parseFloat('0' + numvalue.replace(/,/g, ''));
}
// (){} 小数点以下ゼロ付加
function $6aa1fa05a881063f$var$fixedRate(numvalue, n) {
    p = (numvalue + '.').split('.');
    if (p[0].length == 0) p[0] = '0';
    if (n > 0) return p[0] + '.' + (p[1] + Array(n + 1).join('0')).substr(0, n);
    else return p[0];
}
// (){} 整数表現
function $6aa1fa05a881063f$var$stoRateInt(numvalue) {
    p = (numvalue + '.').split('.');
    return parseInt(p[0] + p[1]);
}
// (){} カンマ付加 
function $6aa1fa05a881063f$var$sepCurr(numvalue) {
    return numvalue.replace(/^(-?[0-9]+)(?=\.|$)/, function(s) {
        return s.replace(/([0-9]+?)(?=(?:[0-9]{3})+$)/g, '$1,');
    });
}
// (){} シフト後、整数表現
function $6aa1fa05a881063f$var$stoFixedRateInt(numvalue, n) {
    var p1 = (numvalue + '.').split('.');
    if (p1[0].length == 0) p1[0] = '0';
    var q = (p1[0] + '.' + (p1[1] + Array(n + 1).join('0')).substr(0, n) + '.').split('.');
    return parseInt(q[0] + q[1]);
}

})();
//# sourceMappingURL=fp6x2.js.map
